import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const reportingDaysPastDueOverduePaymentsAPI = async (params: {
  dueDays: number;
  format?: string;
}) => {
  const response = await baseAPI.get<string>(
    '/reporting/days-past-due-overdue-payments',
    {
      params,
      responseType: 'text',
    },
  );
  return response.data;
};

export const useReportingDaysPastDueOverduePayments = (params: {
  dueDays: number;
  format?: string;
}) => {
  return useQuery({
    queryKey: [KEYS.DAYS_PAST_DUE_OVERDUE_PAYMENTS, params],
    queryFn: () => reportingDaysPastDueOverduePaymentsAPI(params),
    enabled: !!params.dueDays && !!params.format,
  });
};
